import textFieldRules from '@/textFieldRules'
import moment from 'moment'

const getInitials = (text, fallback = '', separator = ' ') => {
  if (!text) {
    return fallback
  }

  const comps = text.trim().split([separator])
  const resultComps = []
  for (let i = 0; i < Math.min(comps.length, 2); i++) {
    resultComps.push(comps[i][0].toUpperCase())
  }

  return resultComps.join('')
}

const formattedDate = (date) => {
  return moment(date).format('DD/MM/YY')
}

export { getInitials, textFieldRules, formattedDate }
